const waiters = new Map();
let sequence = 0;

export function songKey(row) {
    if (!row) return '';
    const id = row.id || row.musicId || '';
    return String(row.source || 'qq').toLowerCase() + ':' + String(id || row.name || '').trim();
}

export function latestPickRequest(requests, row) {
    const key = songKey(row);
    return (requests || []).slice().reverse().find(item => item.key === key);
}

export function receivePickResult(store, data) {
    if (!data || !data.requestId || !['processing', 'queued', 'failed'].includes(data.status)) return;
    const request = store.getters.getPickRequests.find(item => item.requestId === data.requestId);
    if (!request) return;
    if (request.status === 'queued' || request.status === 'failed') return;
    if (request.status === 'unconfirmed' && data.status === 'processing') return;
    store.commit('updatePickRequest', data);
    if (data.status !== 'processing') settle(data.requestId, {...request, ...data});
}

function settle(requestId, result) {
    const waiter = waiters.get(requestId);
    if (!waiter) return;
    clearTimeout(waiter.timer);
    waiters.delete(requestId);
    waiter.resolve(result);
}

// A lost reply is not proof that the server rejected the song.
export function interruptPickRequests(store) {
    store.getters.getPickRequests.filter(item => item.status === 'processing').forEach(item => {
        const result = {...item, status: 'unconfirmed', reason: '连接中断，结果待确认，请查看待播队列'};
        store.commit('updatePickRequest', result);
        settle(item.requestId, result);
    });
}

export function requestPick(store, row, options = {}) {
    const stomp = store.getters.getStompClient;
    if (!row || !(row.id || row.musicId || row.name)) {
        return Promise.resolve({status: 'failed', reason: '歌曲信息不完整'});
    }
    const previous = latestPickRequest(store.getters.getPickRequests, row);
    if (!options.notSubmittedReason && previous && previous.status === 'processing' && waiters.has(previous.requestId)) {
        if (options.batchId) store.commit('updatePickRequest', {requestId: previous.requestId, batchId: options.batchId});
        return waiters.get(previous.requestId).promise;
    }
    const requestId = 'pick-' + Date.now().toString(36) + '-' + (++sequence).toString(36) + '-' + Math.random().toString(36).slice(2, 10);
    const item = {
        requestId, key: songKey(row), musicId: String(row.id || row.musicId || ''),
        source: row.source || 'qq', name: row.name || row.id || row.musicId,
        status: 'processing', reason: '正在处理', batchId: options.batchId || '', time: Date.now()
    };
    store.commit('beginPickRequest', item);
    if (options.notSubmittedReason) {
        const result = {...item, status: 'failed', reason: options.notSubmittedReason};
        store.commit('updatePickRequest', result);
        return Promise.resolve(result);
    }
    if (!store.getters.getIsConnected || !store.getters.getIdentityReady || !stomp || typeof stomp.send !== 'function') {
        const result = {...item, status: 'failed', reason: '尚未连接或身份正在恢复，本首未提交'};
        store.commit('updatePickRequest', result);
        return Promise.resolve(result);
    }
    const waiter = {};
    waiter.promise = new Promise(resolve => { waiter.resolve = resolve; });
    waiter.timer = setTimeout(() => {
        const result = {...item, status: 'unconfirmed', reason: '等待结果超时，请查看待播队列后再试'};
        store.commit('updatePickRequest', result);
        settle(requestId, result);
    }, 90000);
    waiters.set(requestId, waiter);
    try {
        stomp.send('/music/pick', {}, JSON.stringify({
            requestId, id: item.musicId || undefined, name: item.name, source: item.source, sendTime: item.time
        }));
    } catch (e) {
        const result = {...item, status: 'unconfirmed', reason: '发送中断，请查看待播队列后再试'};
        store.commit('updatePickRequest', result);
        settle(requestId, result);
    }
    return waiter.promise;
}
